module.exports = __webpack_public_path__ + "e117d9529ec8562094e5413b70c7687d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-14.png
// module id = 2279
// module chunks = 0